export default __webpack_public_path__ + "static/media/zw.f5ceeff7.svg";